import { render } from "./TabC.vue?vue&type=template&id=06b3a714&scoped=true"
import script from "./TabC.vue?vue&type=script&lang=js"
export * from "./TabC.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-06b3a714"

export default script